module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "toctitle"
  }, [_c('i', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/preface"
    }
  }, [_vm._v("PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/guide"
    }
  }, [_vm._v("USING THE GUIDE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/abbreviations"
    }
  }, [_vm._v("ABBREVIATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/publish"
    }
  }, [_vm._v("AMERICAN AGENTS, DISTRIBUTORS, OR PARENT COMPANIES OF MUSIC PUBLISHERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/address"
    }
  }, [_vm._v("ADDRESSES OF MUSIC PUBLISHERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/part1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART I")]), _vm._v(": "), _c('i', [_vm._v("Individual Composers: Their Solo Piano Works in Various Editions and Facsimile Reproductions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART II")]), _vm._v(": "), _c('i', [_vm._v("Anthologies and Collections")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Collections Spanning Historical Periods")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baroque")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classical Period")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nineteenth-Century Romanticism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twentieth Century to 2010")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tombeaux, Hommages")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("African")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("American")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Australian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Austrian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belgian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brazilian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bulgarian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/part2#sub14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Canadian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub15"
    }
  }, [_vm._v("Chinese")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub16"
    }
  }, [_vm._v("Czech")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub17"
    }
  }, [_vm._v("Dutch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub18"
    }
  }, [_vm._v("English")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub19"
    }
  }, [_vm._v("English Virginalists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub20"
    }
  }, [_vm._v("Finnish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub21"
    }
  }, [_vm._v("French")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub22"
    }
  }, [_vm._v("French Clavecinists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub23"
    }
  }, [_vm._v("German")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub24"
    }
  }, [_vm._v("German: Bach Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub25"
    }
  }, [_vm._v("Greek")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub26"
    }
  }, [_vm._v("Hungarian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub27"
    }
  }, [_vm._v("Irish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub28"
    }
  }, [_vm._v("Israeli")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub29"
    }
  }, [_vm._v("Italian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub30"
    }
  }, [_vm._v("Japanese")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub31"
    }
  }, [_vm._v("Latin American")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub32"
    }
  }, [_vm._v("New Zealand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub33"
    }
  }, [_vm._v("Polish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub34"
    }
  }, [_vm._v("Portuguese")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub35"
    }
  }, [_vm._v("Romanian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub36"
    }
  }, [_vm._v("Russian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub37"
    }
  }, [_vm._v("Scandinavian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub38"
    }
  }, [_vm._v("Scottish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub39"
    }
  }, [_vm._v("Slovakian")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub40"
    }
  }, [_vm._v("Spanish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub41"
    }
  }, [_vm._v("Swiss")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/part201#sub42"
    }
  }, [_vm._v("Yugoslavian")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/app",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX: "), _c('i', [_vm._v("Historical Recital Programs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/app#sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anton Rubinstein, 1885–1886")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/app#sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ferruccio Busoni, 1911")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/app#sub3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ossip Gabrilowitsch, 1915–1916")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEXES:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/index#sub1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alphabetical List of Composers under Nationality Designations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/index#sub2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Compositions for Piano and Live or Recorded Electronics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/index#sub3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Compositions for Prepared Piano")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/index#sub4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Index to Anthologies and Collections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/index#sub5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Index to "), _c('i', [_vm._v("Anatomy of a Classic, Virtuoso")]), _vm._v(" Series, and Van Cliburn Competition–Commissioned Works and Publishers")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70ac24c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 66
// module chunks = 0